var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBubbleOvalSmiley = function SvgChatBubbleOvalSmiley(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#chat-bubble-oval-smiley_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDE1E4",
    d: "M28.612 2.137a19.829 19.829 0 0 0-25.52 28.217L.26 37.897a1.429 1.429 0 0 0 1.592 1.909l9.88-1.789a19.828 19.828 0 0 0 16.88-35.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M15.537 14.197a2.143 2.143 0 1 1-4.285 0 2.143 2.143 0 0 1 4.285 0m-5.443 6.94a1.785 1.785 0 0 1 2.2 1.243c1.149 4.146 5.82 6.757 10.017 5.631 2.635-.98 4.715-3.125 5.395-5.623a1.785 1.785 0 0 1 3.445.938c-1.028 3.771-4.062 6.751-7.685 8.065q-.065.024-.132.043c-6.068 1.686-12.785-1.983-14.485-8.1a1.786 1.786 0 0 1 1.245-2.2zm16.515-4.8a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chat-bubble-oval-smiley_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgChatBubbleOvalSmiley;